import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { OccupationModel } from '@app/ps/models/occupation.model';
import { TooltipDisabledOccupationComponent } from '@app/common/components/tooltip-disabled-occupation/tooltip-disabled-occupation.component';
import { TooltipFinalSolutionStateComponent } from '@app/ps/occupations/components/tooltip-final-solution-state/tooltip-final-solution-state.component';
import {BrandService} from "@app/common/services/brand.service";
import {
  OccupationApproveComponent
} from "@app/ps/occupations/components/occupation-approve/occupation-approve.component";
import { DialogService } from "@app/common/services/dialog.service";
import { ApproveFinalSolutionTypeService } from "@app/common/services/approve-final-solution-type.service";
import { FinalSolutionStateEnum } from '@app/ps/enums/final-solution-state.enum';
import { AuthService} from "@app/common/services/auth.service";

@Component({
  selector: 'cell-occupation',
  templateUrl: './cell-occupation.component.html',
  styleUrls: ['./cell-occupation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CellOccupationComponent implements OnInit {

  @Input() occupation: OccupationModel;
  @Input() showSwitch = false;
  @Input() showUpdate = false;
  @Input() type: 'occupation' | 'phase' | 'edit' = 'occupation';
  @Input() visibleApprove: boolean = true;

  constructor(
    private brandService: BrandService,
    private dialogService: DialogService,
    private cdr: ChangeDetectorRef,
    public approveFinalSolutionTypeService: ApproveFinalSolutionTypeService,
    private authService: AuthService
  ) {}

  finalSolutionEnabled = false;
  priorityEnabled = false;
  canApproveFinalSolutionType = false;
  visibleFinalSolutionType = false;
  tooltipComponent = TooltipDisabledOccupationComponent;
  readonly tooltipFinalSolutionStateComponent = TooltipFinalSolutionStateComponent;
  protected readonly FinalSolutionStateEnum = FinalSolutionStateEnum;

  ngOnInit() {
    const project = this.authService.getActualProject();
    this.visibleFinalSolutionType = !!this.occupation.finalSolutionType && this.brandService.isVisible('mpv') && project.type === 'ADDITIONAL';
    // TODO rozsireni pro typ akce 'INVEST'
    // this.visibleFinalSolutionType = !!this.occupation.finalSolutionType && this.brandService.isVisible('mpv') && (project.type === 'ADDITIONAL'|| project.type === 'INVEST');
    this.finalSolutionEnabled = this.visibleFinalSolutionType && ((this.occupation.countCasesNotOwnersStatementLiability === 0 && project.type === 'ADDITIONAL'));
    this.priorityEnabled = project.occupationsPriority && project.occupationsPriority.enabled;

    if (this.priorityEnabled || this.finalSolutionEnabled) {
      this.showUpdate =  this.showUpdate && this.type !== 'phase' && (this.occupation.countCases - this.occupation.countCasesFuture) === 0;
    } else {
      this.showUpdate = this.showUpdate &&
        this.type !== 'phase' &&
        (
          this.occupation.occupationType.category === 'underOneYear' || this.occupation.occupationType.category === 'overOneYear' ||
          ((this.occupation.zabtyp == 3 || this.occupation.zabtyp == 7 || this.occupation.zabtyp == 12 || this.occupation.zabtyp == 121 || this.occupation.zabtyp == 122) && !this.brandService.isVisible('mpv'))
        ) &&
        (this.occupation.countCases - this.occupation.countCasesFuture) === 0;
    }
    this.canApproveFinalSolutionType = this.approveFinalSolutionTypeService.canApproveFinalSolutionType();
  }

  onApproveOccupation(occupation: OccupationModel) {
    const dialog = this.dialogService.open(OccupationApproveComponent, {
      data: { occupation },
    });

    const sub = dialog.afterClosed.subscribe((result) => {
      sub.unsubscribe();
      if (result) {
        this.occupation = result;
        this.cdr.markForCheck();
      }
    });
  }
}
